var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerschieben(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Verschieben__Icn/40px/Verschieben",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Verschieben__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Verschieben__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003519,14 L17,18 L23,18 L20.0003519,14 Z M20.0003519,26 L17,22 L23,22 L20.0003519,26 Z",
    id: ".._.._src_svg_Icn_40px_Verschieben__Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2003857,13.399955 L16.2000338,17.399955 C15.7055539,18.0591841 16.1759287,19 17,19 L23,19 C23.8240194,19 24.2944083,18.0592884 23.8000338,17.400045 L20.8003857,13.400045 C20.4004157,12.8666892 19.6004157,12.8666441 19.2003857,13.399955 Z M20.0003519,14 L23,18 L17,18 L20.0003519,14 Z M19.2003857,26.600045 L16.2000338,22.600045 C15.7055539,21.9408159 16.1759287,21 17,21 L23,21 C23.8240194,21 24.2944083,21.9407116 23.8000338,22.599955 L20.8003857,26.599955 C20.4004157,27.1333108 19.6004157,27.1333559 19.2003857,26.600045 Z M20.0003519,26 L23,22 L17,22 L20.0003519,26 Z",
    id: ".._.._src_svg_Icn_40px_Verschieben__Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerschieben);
export default __webpack_public_path__ + "static/media/Verschieben.72122fd4fe80dd36704e42e53a019cb6.svg";
export { ForwardRef as ReactComponent };